exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".demo-data[data-v-11801437]{margin:1rem 0;display:block}.warning[data-v-11801437]{margin:.5rem 0}", ""]);
